export const LAYER_DEFAULTS = {
    slot: "top" as const,

    symbolLayout: {
        "icon-allow-overlap": true,
        "text-allow-overlap": true,
    },

    textLayout: {
        "text-font": ["Open Sans Semibold", "Arial Unicode MS Regular"] as string[],
        "text-size": 12,
        "icon-text-fit": "both" as const,
        "icon-text-fit-padding": [0, 0, 0, 0] as [number, number, number, number],
    },

    textPaint: {
        "text-color": "#ffffff",
    },

    iconColor: {
        onMarker: "#FFFFFF",
        onLight: "#000000",
        draggableIndicator: "#3E3E3E",
    },

    circle: {
        radius: 20,
        color: "#959595",
    },

    line: {
        width: 6,
    },

    lineIcons: {
        spacing: 400,
        size: 0.4,
        offset: [0, -35] as [number, number],
        textSize: 12,
        textOffset: [1.3, -1.2] as [number, number],
    },
} as const;
